<template>
  <div v-if="tags.length" class="viewport" aria-hidden="true">
    <p class="menu-tag-legend">
      <menu-tag v-for="tag in tags" :key="tag.mt_id" :tag="tag" :menu-type="menuType || 'visual'"></menu-tag>
    </p>
  </div>
</template>

<script lang="ts">
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.2.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-03-10 (1.0.0) (jhoward)
 *      -
 *
 *    2023-04-24 (1.1.0) (jhoward)
 *      - Add TypeScript support to <menu-tag-legend>.
 *
 *    2024-07-16 (1.1.1) (jhoward)
 *      - Add legend-specific CSS for menu tags to <menu-tag-legend>.
 *
 *    2024-07-19 (1.1.2) (jhoward)
 *      - Render tag titles as after pseudo-element in <menu-tag-legend>.
 *
 *    2025-02-12 (1.1.3) (jhoward)
 *      - Add custom style to prime black and white tag in <menu-tag-legend>.
 *
 *    2025-04-08 (1.2.0) (jhoward)
 *      - Remove <menu-tag-legend>::tags computed property.
 *      - Remove "items" property in <menu-tag-legend>.
 *      - Add "tags" property in <menu-tag-legend>.
 */

import {defineComponent, PropType} from "vue";
import MenuTag from "./menu-tag.vue";
import {MenuTagModel} from "./defs";

export default defineComponent({
  components: {
    MenuTag
  },
  name: 'menu-tag-legend',
  props: {
    tags: {
      type: Array as PropType<MenuTagModel[]>,
      required: true
    },
    menuType: {
      type: String,
      default: 'visual',
      validator(value: string) {
        return ['visual', 'textual'].includes(value);
      }
    }
  },
})
</script>

<style scoped>
.menu-tag-legend .menu--tag {
  width: auto;
  white-space: nowrap;
  padding-left: 2.25em;
  margin: 0 2.5em 0 0;
  background-position-x: 0;
  line-height: 2em;
  vertical-align: middle;
  display: initial;
}

.textual_menu--container .menu-tag-legend .menu--tag.tag-prime-bnw {
  padding-left: 4em;
}

.visual_menu--container .menu-tag-legend .menu--tag {
  line-height: inherit;
}

.menu-tag-legend .menu--tag::after {
  content: attr(title);
}
</style>